import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import { RekbotStatusType } from "../models/rekbot-status-type.model";

@Injectable({
  providedIn: 'root'
})

export class StatusTypeService {


    constructor(
        private http: HttpClient,
        private authService: AuthService
    ) {
    }

    getAllStatusTypes() {
        const endpoint = environment.apiUrl + "/api/message-types";
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.get<RekbotStatusType[]>(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    getStatusType(id:string) {
        const endpoint = environment.apiUrl + "/api/message-types/"+id;
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.get<RekbotStatusType>(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    createStatusType(body:RekbotStatusType) {
        const endpoint = environment.apiUrl + "/api/message-types";
        const bearerToken = "Bearer " + this.authService.getToken()
        
        return this.http.post(endpoint, body ,{ headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    updateStatusType(id:string, body:any) {
        const endpoint = environment.apiUrl + "/api/message-types/"+id;
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(endpoint, body ,{ headers: new HttpHeaders().set("Authorization", bearerToken) })
    }

    removeStatusType(id:string) {
        const endpoint = environment.apiUrl + "/api/message-types/"+id;
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.delete(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) })
    }
}
